import React from 'react';
import { Link } from 'react-router'

function Tools({
  count,
  deleteSponsors
}) {
  return (
    <div className="admin_list">
      <h5>Sponsors (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/sponsors/new">Add sponsor</Link>
      <a className="button_delete" onClick={deleteSponsors}>Delete</a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/Sponsor/Toolbar/Tools.jsx